// src/components/SeoHelmet.js
import { Helmet } from "react-helmet-async";

const SeoHelmet = ({
  title,
  description,
  keywords,
  image,
  url,
  type = "website",
  schema,
}) => {
  const fullTitle = title ? `${title}` : "Virtue’s Shop";
  const author = "Virtue’s Shop - Fresh Food Delivery in Lagos";

  return (
    <Helmet>
      {/* Basic SEO */}
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="author" content={author} />
      <link rel="canonical" href={url || "https://app.virtuesshop.co/"} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url || "https://app.virtuesshop.co/"} />
      <meta property="og:type" content={type} />

      {/* Twitter */}
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:card" content="summary_large_image" />

      {/* Structured Data */}
      {schema &&
        (Array.isArray(schema) ? (
          schema.map((s, i) => (
            <script key={i} type="application/ld+json">
              {JSON.stringify(s)}
            </script>
          ))
        ) : (
          <script type="application/ld+json">{JSON.stringify(schema)}</script>
        ))}
    </Helmet>
  );
};

export default SeoHelmet;
